module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud contenedor-interno"
  }, [(_vm.mostrarConfirmacionGestionar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionGestionar = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarGestionar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionGestionar = false
      },
      "do": _vm.gestionarRenovacion
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea indicar que ya se realizo la renovación?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Confirmando...")] : [_vm._v("Confirmar")]], 2)])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes aprobadas")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._m(0), _c('div', {
    staticClass: "contenedor-fechas-boton"
  }, [_c('div', [_c('p', [_vm._v("Fecha fin de contrato")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFinContrato),
      expression: "fechaFinContrato"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFinContrato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFinContrato = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "padding-left-20"
  }, [_c('div', {
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._m(1), _c('span', [_vm._v("Refrescar")])])])])]), _c('div', {
    staticClass: "body"
  }, [(!_vm.isLoading) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(2), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigo
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('div', {
      staticClass: "show-break-1"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Renovacion:")]), _c('br'), (o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [(o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])]), _c('td', [_vm._v(_vm._s(o.descripcionEstado))]), _c('td', [_c('span', [_vm._v(_vm._s(o.creadoPor))]), _c('br'), _c('div', {
      staticClass: "show-break-1"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Vencimiento:")]), _c('br'), _c('span', [_vm._v(_vm._s(o.fechaFinContrato))]), _c('br'), _c('div', {
      staticClass: "button is-small is-info mt-5",
      on: {
        "click": function($event) {
          return _vm.confirmacionYaSeGestiono(o)
        }
      }
    }, [_vm._m(3, true), _c('span', [_vm._v("Ya se gestionó")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.fechaFinContrato))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('div', {
      staticClass: "button is-small is-info",
      on: {
        "click": function($event) {
          return _vm.confirmacionYaSeGestiono(o)
        }
      }
    }, [_vm._m(4, true), _c('span', [_vm._v("Ya se gestionó")])])])])])
  }), 0)], 1) : _vm._e(), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Solo aparecen las solicitudes de renovación aprobadas por la gerencia")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Gestione la renovación de contrato")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud desaparecerá de la lista, cuando se envíe la información desde el sistema de planillas")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Tipo renovación")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Creado por")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Fecha vencimiento")]), _c('th', {
    staticClass: "hide-break-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw fa-lg"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e70b8266","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas.vue
// module id = 889
// module chunks = 0